export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_brtrtecnologia.png",
      alt: "Nome da extensão",
    },
    title: "Estratégias Inovadoras",
    text: [
      "Oferecemos estratégias confiáveis, garantindo uma experiência completa para traders iniciantes e experientes. Nosso compromisso é entregar inovação, performance estatística, alcançando consistência e disciplina no mercado.",
      "Venha descobrir um novo patamar em investimentos automatizados e faça parte da revolução no trading com tecnologia de ponta.",
    ],
    testimonial: {
      text: "Estratégias sólidas, construídas com pesquisa e aprimoramento contínuo, são a base da nossa atuação.",
      author: {
        name: "Tiago Alves, CEO BRTR Tecnologia.",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  features: {
    title: "Por que utilizar os robôs da BRTR Tecnologia?",
    subtitle: "Veja quais as principais vantagens dos robôs da BRTR Tecnologia.",
    data: [
      {
        description: "Todo assinante pode escolher 1 estratégia e testar por 30 dias.",
      },
      {
        description:
          "Nossas estratégias utilizam funções de avaliação (Sharpe, Taxa de acerto, Retorno esperado), validação estatística e testes de robustez Walk-Foward Analysis, Walk-Foward Matrix.",
      },
      {
        description: "Automação total da operação, eliminando a necessidade de monitoramento constante.",
      },
      {
        description: "Execução rápida e precisa das ordens, fundamental para ativos de alta volatilidade. ",
      },
      {
        description: "Eliminação do impacto das emoções sobre as decisões de compra e venda.",
      },
      {
        description: "Aplicação disciplinada das estratégias de trading, sem desvios.",
      },
    ],
  },
  cta: {
    title: "Faça parte!",
    subtitle: "Ative agora a extensão.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A BRTR TECNOLOGIA",
    col1: [
      "Somos uma empresa inovadora especializada no desenvolvimento de Expert Advisors para o mercado financeiro, com foco em mini índice e mini dólar. Nossa missão é potencializar os investimentos de nossos clientes por meio de soluções automatizadas, que unem tecnologia avançada e estratégias testadas para maximizar resultados com segurança e eficiência.",
      "Atuamos na criação de robôs inteligentes que operam 100% automatizados, eliminando emoções e otimizando operações em tempo real. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão BRTR Tecnologia",
  },
  strategies: {
    title: "BRTR Tecnologia – Algoritmos a favor do seu capital",
    heading: "Robôs que analisam, decidem e operam com precisão.",
    subtitle: "Estratégias inteligentes, performance constante — sem complicação.",
  },
};
